let isUpdateCart = false;

//加载完成再添加事件，因为需要等待导航栏插件返回数据

window.addEventListener("load", (event) => {
  Promise.resolve().then(addCartHover);
});
window.onscroll = (e) => {
  //滚动就隐藏导航栏购物车
  isUpdateCart &&
    leaveCartDialog({
      target: { id: "page-cart-hover" },
    });
};
//cart图标hover展示,
function addCartHover() {
  //只有pc端并且不在购物车页面才展示
  if (document.body.clientWidth < 1000 || location.pathname === "/cart") {
    return;
  }
  document
    .getElementById("cart-icon-bubble")
    ?.addEventListener("mouseenter", (e) => {
      if (!isUpdateCart) {
        initCartItem();
        isUpdateCart = true;
      }
      let pageCartEl = document.getElementById("page-cart-hover");
      if (pageCartEl && e.target) {
        pageCartEl.style.display = "block";
        if (pageCartEl.className.indexOf("active") === -1) {
          pageCartEl.classList.add("active");
        }
        pageCartEl.style.top = e.target.offsetTop + 30 + "px";
        pageCartEl.style.right = `calc(100% - ${e.target.offsetLeft - 10}px)`;
        pageCartEl.addEventListener("mouseleave", leaveCartDialog);
      }
    });
}
//隐藏cart弹窗
function leaveCartDialog(e) {
  let pageCartEl = document.getElementById("page-cart-hover");

  if (
    e.target.id === "page-cart-hover" &&
    e.relatedTarget !== "page-cart-hover" &&
    pageCartEl
  ) {
    isUpdateCart = false;
    pageCartEl.classList.remove("active");
    setTimeout(() => {
      if (pageCartEl?.className?.indexOf("active") === -1) {
        pageCartEl.style.display = "none";
      }
    }, 2000);
    document
      .getElementById("page-cart-hover")
      ?.removeEventListener("mouseleave", leaveCartDialog);
  }
}
//初始化购物车数据
async function initCartItem() {
  toggleLoading("show");
  const res = await fetch("/cart.js").then((res) => res.json());

  res?.items?.[0]
    ? updateQuantity("1", res.items[0].quantity)
    : toggleLoading("hide");
}
//默认更新数量，因为只有更新数量才会获取到节点更新dom
function updateQuantity(line, quantity, name) {
  const body = JSON.stringify({
    line,
    quantity,
    sections: getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname,
  });

  fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);

      document
        .getElementById("page-cart-hover")
        ?.querySelector(".is-empty")
        ?.classList.remove("is-empty");
      getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);

        elementToReplace.innerHTML = getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });
      if (
        document
          ?.getElementById("page-cart-hover")
          ?.querySelector("#cart-hover-total")
      ) {
        let priceStr = getSectionInnerHTML(
          parsedState.sections["cart-live-region-text"],
          ".shopify-section"
        );

        document
          .getElementById("page-cart-hover")
          .querySelector("#cart-hover-total").innerText =
          priceStr.split(":")[1] || priceStr.split(":")[0];
      }
      toggleLoading("hide");
    })
    .catch((e) => {
      // console.error(e);
      const errors = document.getElementById("cart-errors");
      // errors.textContent = window.cartStrings.error;
      toggleLoading("hide");
    });
}
function getSectionsToRender() {
  return [
    {
      id: "main-cart-items",
      section: document.getElementById("main-cart-items").dataset.id,
      selector: ".js-contents",
    },
    {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: ".shopify-section",
    },
    {
      id: "cart-live-region-text",
      section: "cart-live-region-text",
      selector: ".shopify-section",
    },
    {
      id: "main-cart-footer",
      section: document.getElementById("main-cart-footer").dataset.id,
      selector: ".js-contents",
    },
  ];
}
function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, "text/html")
    ?.querySelector(selector)?.innerHTML;
}
//切换loading
function toggleLoading(type) {
  const loadingEl = document.getElementById("cart-hover-loading");

  if (type === "hide") {
    loadingEl?.classList.add("hidden");
  } else {
    loadingEl?.classList.remove("hidden");
  }
}
